import {ChangeDetectorRef, Component, type AfterViewInit, input, OnInit} from '@angular/core';
import {
  ClassicEditor,
  Bold,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Essentials,
  Heading,
  Italic,
  List,
  Link,
  Paragraph
} from 'ckeditor5';
import {CommonModule} from "@angular/common";
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import 'ckeditor5/build/translations/it';

@Component({
  selector: 'app-editor',
  standalone: true,
  imports: [CommonModule, CKEditorModule, ReactiveFormsModule],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.css'
})
export class EditorComponent implements OnInit {

  label = input<string>();
  control = input.required<FormControl>();

  constructor(private changeDetector: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    if (!this.control().value) {
      this.control().setValue("");
    }
  }

  public Editor = ClassicEditor;
  public config = {
    licenseKey: 'GPL',
    plugins: [Heading, FontBackgroundColor, FontColor, FontFamily, FontSize, Essentials, Paragraph, Bold, Italic, Link, List],
    language: 'it',
    toolbar: ['heading', 'bold', '|', 'link', 'bulletedList', 'numberedList'],
    clipboard: {
      pastePlainText: true
    }
  }

  onReadyEditor(editor) {
  }

}

